export const appStateSliceName = "app-state";